export interface TextboxConfig {
  id: string | null;
  label?: string | null;
  placeholder?: string | null;
  value?: string | number | null;
  // Type and behaviour
  type?: InputType;
  disabled?: boolean;
  readonly?: boolean;
  // rows removed: component no longer renders textarea

  // Validation states
  isValid?: boolean;
  isInvalid?: boolean;
  helperText?: string | null;
  rightSideText?: string | null;
  rightSideTextClass?: string | null; // for styling the right side text
  // optional currency label to show inside the control (e.g. "USD")
  currencyText?: string | null;
  countryPhoneCode?: string | null;
  chevronInput?: boolean;
  required?: boolean;
  // Icon
  iconSrc?: string | null; // path to svg/png
  iconPosition?: 'left' | 'right';

  // appearance
  size?: 'sm' | 'md' | 'lg';
  // constraints
  maxLength?: number | string | null;
  maxLengthCount?: number | string | null; //To show the max length count below the input
  max?: number | string | null;  // for type="number": maximum allowed value
  min?: number | string | null;  // for type="number": minimum allowed value
  iconColor?: string;
}

export const DEFAULT_TEXTBOX_CONFIG: TextboxConfig = {
  id: null,
  label: null,
  placeholder: '',
  value: null,
  type:'text',
  disabled: false,
  readonly: false,
  isValid: false,
  isInvalid: false,
  helperText: null,
  rightSideText: null,
  rightSideTextClass: null,
  currencyText: null,
  countryPhoneCode: null,
  chevronInput:false,
  required: false,
  iconSrc: null,
  iconPosition: 'right',
  size: 'md',
  maxLength: null,
  maxLengthCount: null,
  max: null,
  min: null,
  iconColor: 'primary'
};


type InputType = 'text' | 'password' | 'email' | 'number' | 'date' | 'tel' | 'search' | 'input';